<span [class.fst-italic]="condition | conditionShouldBeItalic:attribute.constraint"
      class="mx-1">{{condition | translateCondition:attribute}}</span>
<ng-container *ngFor="let conditionValue of conditionValues; let index = index">
  <ng-container *ngIf="index < (condition | conditionNumValues)">
    <span *ngIf="index > 0">,&nbsp;</span>
    <data-input-preview *ngIf="!conditionValue.type" [class.ms-1]="index === 0"
                        [dataValue]="conditionValue.value | dataValue:attribute.constraint:constraintData"
                        [configuration]="configuration"
                        [constraint]="attribute.constraint">
    </data-input-preview>
    <span class="ms-1" [class.ms-1]="index === 0"
          *ngIf="conditionValue.type">{{conditionValue.type | translateConditionValue:attribute}}</span>
  </ng-container>
</ng-container>
